import ConfigChangeLogTable from "../../../views/ConfigChangeLog";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const ConfigChangeLogRoutes = [
  {
    menuName: MenuNames.CONFIG,
    path: "/gen-setting/change-logs",
    component: ConfigChangeLogTable,
    exact: true,
  },
  {
    menuName: MenuNames.CONFIG,
    path: "/city-property/change-logs/:id(\\d+)",
    component: ConfigChangeLogTable,
    exact: true,
  },
];

export default ConfigChangeLogRoutes;
